<div class="sidenav--option" matRipple (click)="service.navigate('search')">
  <p translate="profile.newsfeed"></p>
</div>
<div class="sidenav--option active" matRipple>
  <p>{{ ((service.stateService.selfProfile$ | async) ? 'profile.my-profile' : 'profile.profile') | translate }}</p>
</div>
<div class="sidenav--option" matRipple (click)="service.navigate('community')">
  <p translate="profile.community"></p>
</div>
